import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';
import { FinancialServicesSegment } from '../../models/provider';
import { translateRefreshableItemsToScopes } from '../../models/refreshableItem';
import {
  getInvalidTransactionsRefreshableItems,
  getTransactionsRefreshableItems,
} from '../transactions/common';
import { ERR_PARAM_REFRESHABLE_ITEMS_INVALID } from '../../utilities/error';
import { ValidateProductParams } from '../../utilities/urlParameters';

const DEFAULT_FINANCIAL_SERVICES_SEGMENTS = [
  FinancialServicesSegment.PERSONAL,
  FinancialServicesSegment.BUSINESS,
];

export const validateParams: ValidateProductParams = (commonParams, getRawParam) => {
  const errors = [];

  // TODO: Add `authorizationCode` validation for perm user cases: continuous access / update consent

  const { financialServicesSegments } = commonParams;

  const transactionRefreshableItems = getTransactionsRefreshableItems(
    getRawParam(TinkLinkUrlParameter.REFRESHABLE_ITEMS)
  );
  const scope = translateRefreshableItemsToScopes(transactionRefreshableItems);

  const invalidTransactionsRefreshableItems = getInvalidTransactionsRefreshableItems(
    getRawParam(TinkLinkUrlParameter.REFRESHABLE_ITEMS)
  );

  if (invalidTransactionsRefreshableItems.length > 0) {
    errors.push(ERR_PARAM_REFRESHABLE_ITEMS_INVALID);
  }

  return {
    parameters: {
      scope,
      refreshableItems: transactionRefreshableItems,
      financialServicesSegments: financialServicesSegments || DEFAULT_FINANCIAL_SERVICES_SEGMENTS,
    },
    errors,
  };
};
